module.exports = __webpack_public_path__ + "img/q2.c003076c.png";